import {createSelector, createSlice} from '@reduxjs/toolkit'
import {apiCore} from "../apiSlice/apiCore";

const conditionsFacilitiesApi = apiCore
    .injectEndpoints({
        endpoints: (build) => ({
            getConditionFacility: build.query({
                providesTags: ['get-conditions-facilities'],
                query: () => '/terms/',
            })
        })
    })

export const {useGetConditionFacilityQuery} = conditionsFacilitiesApi;

const conditionSlice = createSlice({
    name: 'conditionSlice',
    initialState: {
        condition: {
            data: {
                pageOne: [
                    {
                        id: 1,
                        title: "داشتن حساب بانکی فعال نزد بانک ایران ونزوئلا."
                    },
                    {
                        id: 2,
                        title: "داشتن سفته الکترونیک و یا یک برگه چک صیادی بنفش یا زرد به نام کاربر. دسته چک‌های قدیمی مورد قبول نیست."
                    },
                    {
                        id: 3,
                        title: "محدودیت سنی 18 تا 70 سال."
                    },
                    {
                        id: 4,
                        title: "داشتن کارت پایان خدمت یا انواع معافیت برای آقایان."
                    },
                ],
                pageTwo: [
                    {
                        id: 5,
                        title: "تایید اعتبارسنجی از سامانه اعتبارسنجی بانک مرکزی، پرداخت هزینه اعتبار سنجی به بانک مرکزی برعهده کاربر است."
                    },
                    {
                        id: 6,
                        title: "اعتبارسنجی سفرمارکت، شامل بررسی رفتار مالی کاربر، شامل عملکرد در خریدهای قبلی."
                    },
                    {
                        id: 7,
                        title: "ثبت‌نام آنلاین در اپلیکیشن سفرمارکت با دریافت امضای دیجیتال."
                    },
                ],
                pageThree: [
                    {
                        id: 8,
                        title: "تکمیل اطلاعات شخصی در پروفایل حساب کاربری سفرمارکت."
                    },
                    {
                        id: 9,
                        title: "مدارک جهت صحت سنجی اطلاعات هویتی، محل زندگی و وضعیت شغلی کاربر شامل؛ تصویر پشت و روی کارت ملی، اجاره نامه یا سند ملکی، فیش حقوقی و چک صیاد."
                    }
                ],
                pageFour: [
                    {
                        id: 10,
                        title: "قبول کلیه قوانین و مقررات کلی سفرمارکت و خدمت خریداری شده توسط کاربر."
                    },
                    {
                        id: 11,
                        title: "مالک خط تلفن همراه که از طریق آن از خدمات سفرمارکت بهره برداری می‌کند مسئول ایفای کلیه تعهدات بوده و هیچگونه عذری در خصوص استفاده دیگران از خط مذکور مسموع نخواهد بود."
                    },
                ],
            },
            status: "idle",
            errorMsg: ""
        }
    },
    reducers: {},
    extraReducers: (builder) => {
    },
})


export const useConditions = createSelector(
    (state) => state.conditionSlice?.condition?.data,
    (data) => {
        return data;
    }
)

export default conditionSlice.reducer